import * as React from 'react';
import { ITranslationProps } from 'types/translation';

import TEXT_KEYS from './add-meta-description.constants';

export default class AddMetaDescription extends React.Component<ITranslationProps> {
    public componentDidMount() {
        this.setMetaDescription();
        this.props.i18n.on('languageChanged', this.setMetaDescription);
    }

    public UNSAFE_componentWillMount() {
        this.props.i18n.off('languageChanged', this.setMetaDescription);
    }

    public setMetaDescription = () => {
        document.querySelectorAll('meta[name="description"]').forEach(node => node.remove());

        const { originalTranslateKey } = this.props;
        const gameName: string = originalTranslateKey(TEXT_KEYS.GAME_NAME);

        const meta = document.createElement('meta');
        meta.name = 'description';
        meta.content = originalTranslateKey(TEXT_KEYS.META_DESCRIPTION_VALUE, { gameName });
        
        document.head.appendChild(meta);
    };

    public render(): React.ReactNode {
        return null;
    }
}
